import * as Yup from "yup";

export const NotificationSchema = Yup.object().shape({
  nome: Yup.string().required("Nome não pode ser vazio"),
  email: Yup.string()
    .email("Informe um e-mail válido")
    .required("E-mail não pode ser vazio"),  
});
